// Module
var code = "<div class=\"row\"> <span class=\"spinme-left\"> <div class=\"spinner\"> <div class=\"bounce1\"></div> <div class=\"bounce2\"></div> <div class=\"bounce3\"></div> </div> </span> </div>";
// Exports
module.exports = code;